/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const marketplace_cancel_listing_info = () => `Wenn Sie es sich anders überlegen, können Sie das Angebot jederzeit stornieren, aber nach dem Verkauf ist es unwiderruflich`
